import { useState } from "react";
import "./ContentTextContainer.css";
const ContentTextContainerTextOnly = ({
    title,
    text,
    alignLeft,
    green,
    animationLeft,
    animationRight,
    onClick,
}) => {
    const [style, setStyle] = useState("contentHelpContainer");
    const [boxStyle, setBoxStyle] = useState("");

    let displayComponent = <></>;

    if (alignLeft && !boxStyle && !animationLeft && !animationRight)
        setBoxStyle("Left");
    if (animationLeft && style !== "contentHelpContainerLeftAnimation")
        setStyle("contentHelpContainerLeftAnimation");
    if (animationRight && style !== "contentHelpContainerRightAnimation")
        setStyle("contentHelpContainerRightAnimation");

    if (text)
        displayComponent = (
            <>
                <div className={style + boxStyle} onClick={onClick}>
                    <h4 className={green ? "greenTitle" : ""}>{title}</h4>
                </div>
            </>
        );

    return displayComponent;
};

export default ContentTextContainerTextOnly;
